<style lang="scss" src='./ShippingMethod.scss' scoped></style>
<template src="./ShippingMethod.html"></template>

<script>
  import {
    mapState,
    mapActions,
    mapMutations
  } from "vuex";
  import UserAddress from './components/userAddress/UserAddress.vue'
  import StoreAdresses from './components/storeAddresses/StoreAddresses.vue'
  export default {
    name: "ShippingMethod",
    components: {
      UserAddress,
      StoreAdresses,
    },
    data() {
      return {
        status: null,
        tabIndex: 1,
      };
    },
    computed: {
      ...mapState('CartStore', ['deliveryMethods','cartProducts']),
    },
    methods: {
      ...mapActions('CartStore', ['fnApiGetDeliveryMethods']),
    },

    beforeCreate() {},

    created() {
      window.fbq('track', 'PageView');
    },

    mounted() {
      if( this.cartProducts.products.length == 0 ){
        this.$router.push('/');
      }
      this.fnApiGetDeliveryMethods();
      if (this.$route.query.tab && (this.$route.query.tab == 'store')) {
        this.tabIndex = 1;
      }
    },

    beforeDestroy() {

    },
  };

</script>
